import { Flex } from '@chakra-ui/react';
import { ReactElement } from 'react';

import { useFocus } from '../Focus';

export const SelectedWidgetToolbar = (): ReactElement => {
  const { widgetToolbarPortalRef } = useFocus();

  return (
    <Flex>
      <div ref={widgetToolbarPortalRef} />
    </Flex>
  );
};
